module.exports = __webpack_public_path__ + "assets/img/modal-avatar-c47ec779.png";